document.addEventListener("click", ({ target }) => {
  if (!target.hasAttribute("data-footer-nav-toggle")) {
    return;
  }

  const parent = target.closest("[data-footer-nav-parent]");

  if (!parent) {
    return;
  }

  parent.classList.toggle("is-opened");
});
